import React from 'react';
import { Markup } from 'interweave';

import styles from '../index.scss';
import { segAndBestEffortAchievementsProps } from '../../../../props/feed-prop-types';

const FeaturedBestEffortAchievements = ({ segAndBestEffortAchievements }) => (
  <>
    {/* Display the first two featured best effort achievements */}
    {segAndBestEffortAchievements
      .filter((elem) => elem && elem.featured)
      .slice(0, 2)
      .map((achievement) => {
        return (
          <li
            data-testid="best_effort_achievement"
            key={achievement.id_string + achievement.name}
          >
            {!achievement.hidden && !achievement.distance_based_best_effort && (
              <a
                href={`/activities/${achievement.activity_id}/segments/${achievement.id_string}`}
                className={styles.achievementsLink}
                data-testid="best_effort_achievement_distance_based_best_effort"
              >
                {achievement.name}
              </a>
            )}
            {!achievement.hidden && (
              <>
                <strong data-testid="best_effort_achievement_description">
                  {achievement.description}
                </strong>
                <span data-testid="best_effort_achievement_elapsed_time">
                  <Markup
                    noWrap={true}
                    content={`&nbsp;(${achievement.elapsed_time})`}
                  />
                </span>
              </>
            )}
          </li>
        );
      })}
  </>
);

FeaturedBestEffortAchievements.propTypes = {
  segAndBestEffortAchievements: segAndBestEffortAchievementsProps
};

FeaturedBestEffortAchievements.defaultProps = {
  segAndBestEffortAchievements: []
};

export default FeaturedBestEffortAchievements;
